<template>

   <div class="row">
      <div class="col-lg-12">
         <div class="panel-group" :id="id" role="tablist" aria-multiselectable="true" >
            <slot></slot>
         </div>
      </div>
   </div>


</template>

<script>
    export default {
        name: "np-collapsible",
        props: {
            id: {
                type: String,
                default: 'accordion'
            },
            open: String // child id
        },
        created: function() {
            //this.$nextTick(() => {
            //        this.openOne(this.open);
            //})
        },
        methods: {
            openOne: function(id) {
                const $closed = $(this.$el).find('.panel-collapse');
                const $open = $(this.$el).find('.panel-collapse in');
                $(this.$el).find('.panel-collapse').not('#' + id).collapse('hide');
                $('#' + id).collapse('show');

                //console.log($closed, $open)
            }
        },
        watch: {
        }

    }
</script>

<style scoped>
</style>